import { useAxios } from "../axiosConfig";


const RosterApi = () => {
    const axiosConfig = useAxios();

    const getRosterListAll = async (langId, userId, pageNo = 1, recordPerPage = 20) => {
        try {
            const response = await axiosConfig.get(`/management/roster/roster-list-all`, {
                headers: {
                    langId
                },
                params: {
                    userId,
                    pageNo,
                    recordPerPage
                }
            });

            return response;
        } catch (error) {
            throw error;
        }
    };

    const addRoster = async (data) => {

        try {
            const response = await axiosConfig.post('/management/add-roster',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const updateRoster = async (data) => {

        try {
            const response = await axiosConfig.post('/management/update-roster',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const deleteRoster = async (data) => {

        try {
            const response = await axiosConfig.post('/management/delete-roster',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const exportRosterCSV = async (data) => {
        try {
            const response = await axiosConfig.post('/management/export-roster', data, {
                responseType: 'blob',
            });
            return response;
        } catch (error) {
            throw error;
        }
    };

    return { getRosterListAll, addRoster, updateRoster, deleteRoster, exportRosterCSV }
}

export default RosterApi